var _path, _line, _path2, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdrawalFee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6418 24.2565C22.0978 23.9449 22.2149 23.3227 21.9033 22.8667C21.5917 22.4107 20.9694 22.2936 20.5134 22.6052L21.6418 24.2565ZM15.5697 24.9897L15.6175 23.9908L15.5697 24.9897ZM10.2359 22.9119L9.59539 23.6799L10.2359 22.9119ZM11.6482 8.12204L11.1647 7.24672L11.6482 8.12204ZM17.2789 7.09131L17.421 6.10145L17.2789 7.09131ZM22.3922 9.66442L21.682 10.3684L21.682 10.3684L22.3922 9.66442ZM23.9286 14.9337C24.0022 15.4811 24.5056 15.8652 25.053 15.7915C25.6004 15.7179 25.9844 15.2145 25.9108 14.6672L23.9286 14.9337ZM20.5134 22.6052C19.0758 23.5876 17.3568 24.0741 15.6175 23.9908L15.5219 25.9885C17.696 26.0926 19.8447 25.4845 21.6418 24.2565L20.5134 22.6052ZM15.6175 23.9908C13.8782 23.9076 12.2136 23.2591 10.8763 22.1439L9.59539 23.6799C11.267 25.0739 13.3478 25.8845 15.5219 25.9885L15.6175 23.9908ZM10.8763 22.1439C9.53904 21.0287 8.60213 19.5076 8.20783 17.8116L6.25978 18.2644C6.75266 20.3845 7.92379 22.2859 9.59539 23.6799L10.8763 22.1439ZM8.20783 17.8116C7.81352 16.1155 7.98335 14.3371 8.69153 12.7464L6.8644 11.933C5.97918 13.9214 5.7669 16.1444 6.25978 18.2644L8.20783 17.8116ZM8.69153 12.7464C9.39971 11.1556 10.6076 9.83933 12.1317 8.99737L11.1647 7.24672C9.25945 8.29917 7.74963 9.94451 6.8644 11.933L8.69153 12.7464ZM12.1317 8.99737C13.6559 8.15541 15.4132 7.83373 17.1368 8.08116L17.421 6.10145C15.2665 5.79216 13.0699 6.19426 11.1647 7.24672L12.1317 8.99737ZM17.1368 8.08116C18.8604 8.32859 20.4562 9.13163 21.682 10.3684L23.1025 8.96047C21.5703 7.41454 19.5755 6.41075 17.421 6.10145L17.1368 8.08116ZM21.682 10.3684C22.9078 11.6051 23.6966 13.208 23.9286 14.9337L25.9108 14.6672C25.6207 12.51 24.6347 10.5064 23.1025 8.96047L21.682 10.3684Z",
    fill: "#DF3030"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 20,
    y2: 16,
    stroke: "#F1A7A7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4877 22.0874L28.3786 20.5978C29.0393 20.0773 29.0467 19.0783 28.3938 18.548L26.4877 16.9999",
    stroke: "#E44E4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.9,
    x1: 1,
    y1: -1,
    x2: 5,
    y2: -1,
    transform: "matrix(-1 4.37114e-08 4.37114e-08 1 26.0004 20.4663)",
    stroke: "#F1A7A7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 5,
    x2: 28,
    y2: 5,
    stroke: "#E44E4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalFee);
export default __webpack_public_path__ + "static/media/withdrawalFee.3f6e4c4efef5a1cce36227bd5a1b7eaa.svg";
export { ForwardRef as ReactComponent };